
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-partners',
  templateUrl: './our-partners.component.html',
  styleUrls: ['./our-partners.component.scss']
})
export class OurPartnersComponent implements OnInit {
  partnersLogo: any[] = [];
  index = 0;
  constructor() { }

  ngOnInit(): void {
    this.partnersLogo = partnersLogo;
  }
  slideConfig = {
    autoplay: true, "slidesToShow": 3, "slidesToScroll": 1,
    "nextArrow": "<div class='btnWrap'> <div class='circle-button nextslide'><img src='assets/svgs/arrow-right-solid-black.svg' class='w-100' alt='left arrow'></div></div>",
    "prevArrow": "<div class='btnWrap'> <div class='circle-button previousSlide'><img src='assets/svgs/arrow-left-solid.svg' class='w-100' alt='left arrow'></div></div>",
  }


  move(direction: -1 | 1) {

    if (direction < 0) {
      this.partnersLogo.push(this.partnersLogo.shift());
    } else {
      this.partnersLogo.unshift(this.partnersLogo.pop())
    }
  }

}

export const partnersLogo = [
  { image: 'partner.png' },
  { image: 'limeLight.svg' },
  // { image: 'partner2.png' },
  { image: 'bata.png' },
  { image: 'partner3.png' },
  { image: 'partner2.png' },
  { image: 'partner.png' },
  { image: 'hadd.svg' },
  { image: 'partner2.png' },
  { image: 'bata.png' },


]